import { useTranslation } from '../../common/components/LocalizationProvider';
import useReportStyles from '../common/useReportStyles';
import SelectField from '../../common/components/SelectField';

const ColumnSelect = ({
  columns, setColumns, columnsArray, rawValues, disabled,
}) => {
  const { classes } = useReportStyles();
  const t = useTranslation();

  return (
    <div className={classes.filterItem}>
      <SelectField
        label={t('sharedColumns')}
        value={columns}
        onChange={(e) => setColumns(e.target.value)}
        multiple
        disabled={disabled}
        fullWidth
        searchPlaceholder={t('sharedSearch')}
        data={columnsArray.map(([key, string]) => ({ key, title: rawValues ? string : t(string) }))}
        keyGetter={(item) => item.key}
        titleGetter={(item) => item.title}
      />
    </div>
  );
};

export default ColumnSelect;
